
import {
  IonApp,
  IonBadge,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
} from "@ionic/vue";
import { defineComponent, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import {
  bookOutline,
  bookSharp,
  personOutline,
  personSharp,
  mailOutline,
  mailSharp,
} from "ionicons/icons";
import {
  CognitoUserInterface,
  onAuthUIStateChange,
  Translations,
} from "@aws-amplify/ui-components";
import { Auth, I18n } from "aws-amplify";
import { useStore, ACTIONS, store } from "./store";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonContent,
    IonIcon,
    IonItem,
    IonBadge,
    IonLabel,
    IonList,
    IonMenu,
    IonMenuToggle,
    IonRouterOutlet,
    IonSplitPane,
  },

  setup() {
    const { t, locale } = useI18n();

    const store = useStore();
    watch(() => store.state.gameStateId,(oldVal,newVal)=> {
      console.log(`value changed from ${oldVal} to ${newVal}`)});
    I18n.putVocabulariesForLanguage("de-DE", {
      [Translations.SIGN_OUT]: "Ausloggen",
      [Translations.SIGN_IN_HEADER_TEXT]: "Bitte melden Sie sich an",
      [Translations.SIGN_IN_ACTION]: "Anmelden",
      [Translations.FORGOT_PASSWORD_TEXT]: "Password vergessen?",
      [Translations.RESET_PASSWORD_TEXT]: "Password zurücksetzen",
      [Translations.NO_ACCOUNT_TEXT]: "Nicht Registriert?",
      [Translations.CREATE_ACCOUNT_TEXT]: "Benutzer anlegen",
      [Translations.PASSWORD_LABEL]: "Passwort*",
      [Translations.PASSWORD_PLACEHOLDER]: "Bitte Passwort eingeben",
      [Translations.EMAIL_LABEL]: "Email Adresse*",
      [Translations.EMAIL_PLACEHOLDER]: "Bitte Email eingeben",
      [Translations.CREATE_ACCOUNT_TEXT]: "Benutzer anlegen",
      [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "Schon registriert?",
      [Translations.SIGN_UP_HEADER_TEXT]: "Benutzer anlegen",
      [Translations.SIGN_IN_TEXT]: "Anmelden",
      [Translations.BACK_TO_SIGN_IN]: "Anmelden",
      [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "Benutzer anlegen",
      [Translations.PREFERRED_USERNAME_LABEL]: "Bevorzugter Benutzername",
      [Translations.PREFERRED_USERNAME_PLACEHOLDER]:
        "Bitte bevorzugten Benutzernamen eingeben",
      [Translations.RESET_PASSWORD_TEXT]: "Passwort zurücksetzen",
      [Translations.RESET_YOUR_PASSWORD]: "Passwort zurücksetzen",
      [Translations.SEND_CODE]: "Code senden",
    });
    const formFields = [
      {
        type: "preferred_username",
        label: "Bevorzugter Benutzername*",
        placeholder: "Bitte bevorzugten Benutzernamen eingeben",
      },
      { type: "email" },
      {
        type: "given_name",
        label: "Vorname*",
        placeholder: "Bitte Vornamen eingeben",
      },
      {
        type: "family_name",
        label: "Nachname*",
        placeholder: "Bitte Nachnamen eingeben",
      },
      { type: "password" },
    ];
    const selectedIndex = ref(0);
    const route = useRoute();
    const curAuthState = ref<any>(null);
    const user = ref<any>(null);
    let unsubscribeAuth: any = null;

    onMounted(() => {
      unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
        curAuthState.value = authState;
        user.value = authData;
        console.log(curAuthState.value);
        if (curAuthState.value == "signedin") {
          Auth.currentAuthenticatedUser()
            .then((data: CognitoUserInterface) => {
              store.dispatch(
                ACTIONS.SET_LOGGED_IN_USER,
                data.attributes.preferred_username
              );
            })
            .catch((err) => {
              console.log(err);
              store.dispatch(ACTIONS.SET_LOGGED_IN_USER, "");
            });
        } else store.dispatch(ACTIONS.SET_LOGGED_IN_USER, "");
      });
    });

    onUnmounted(() => {
      unsubscribeAuth();
    });

    return {
      selectedIndex,
      bookOutline,
      bookSharp,
      personOutline,
      personSharp,
      mailOutline,
      mailSharp,
      isSelected: (url: string) => (url === route.path ? "selected" : ""),
      formFields,
      user,
      curAuthState,
      t,
      locale,
      store,
    };
  },
});
